import Vue from 'vue';
import Component from 'vue-class-component';
import EdHomeworkTeacherSectionPersonItem from '../ed-homework-teacher-section-person-item/ed-homework-teacher-section-person-item.vue';
import EdHomeworkFeedback from '../ed-homework-feedback/ed-homework-feedback.vue';
import EdHomeworkGrade from '../ed-homework-grade/ed-homework-grade.vue';
import EdListHomeworkLoading from '../ed-list-homework-loading/ed-list-homework-loading.vue';
import { STORE } from '@/core/store/core.store';
import { WidgetTeacherSectionList } from '@/homework/models/widget-teacher-section-list.model';
import { Status } from '@/models/status.model';
import { HOMEWORKS_EVENTS, HOMEWORKS_API, HOMEWORK_STATUS, _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { EVENT_BUS } from '@/content/values/events';
import { SECTION_TYPES } from '@/content/values/sections';
import { WidgetTeacherSectionItem } from '@/homework/models/widget-teacher-section-item.model';

@Component({
  components: {
    EdHomeworkTeacherSectionPersonItem,
    EdHomeworkFeedback,
    EdHomeworkGrade,
    EdListHomeworkLoading
  },
})
export default class EdHomeworkTeacherSectionPerson extends Vue {

  public personsStatus: Status = new Status();
  public morePersonsStatus: Status = new Status();
  public myComponent: any = null;
  public currentHomework: any = null;
  public sectionItemSelected: any = null;
  public isSaving: boolean = false;

  get sectionSelected() {
    return this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.sectionSelected;
  }

  get showSeeMore() {
    return this.sectionSelected.users.more;
  }

  get sections() {   
    return this.sectionSelected.users.content;
  }

  get passProps() {
    if(this.myComponent == 'ed-homework-grade') {
      return { params : this.currentHomework, title: this.$i18n.t('homeworks.setGrade') }
    } else if(this.myComponent == 'ed-homework-feedback') {
      return null
    }
    return null;
  }

  reloadSection() : void {
    if(!this.sectionSelected){
      return;
    }
    let sectionReload = {...this.sectionSelected};
    sectionReload.users.page = 0;
    
    this.setSection({section: sectionReload, isReload: true});
  }

  setSection({section, isReload} : { section: WidgetTeacherSectionList, isReload: boolean }) {    
    if(this.sectionSelected && !isReload) {
      let { courseId, classId, id } = this.sectionSelected;
      if(courseId !== section.courseId || classId !== section.classId || id !== section.id) {
        if(section.users.content.length == 0 && section.users.more) {
          this.getPersons(section, isReload);
          return;
        }
      }
      section.users.content.length == 0 ? this.personsStatus.setEmpty() : this.personsStatus.setLoad();
      this.$store.commit(STORE.HOMEWORKS.MUTATIONS.SELECT_WIDGET_TEACHER_SECTION, section);
    } else {
      this.getPersons(section, isReload);
    }
  }

  getMorePersons() {
    this.getPersonsList(this.sectionSelected, this.morePersonsStatus, false);
  }

  getPersons(section: WidgetTeacherSectionList, isReload: boolean) {
    this.getPersonsList(section, this.personsStatus, isReload).then((persons) => {
      if(persons == 0) this.personsStatus.setEmpty();
    });
  }

  getPersonsList(section: WidgetTeacherSectionList, status: Status, isReload: boolean) {
    return new Promise((resolve, reject) => {
      status.setLoading();
      this.$store.dispatch(
        STORE.HOMEWORKS.ACTIONS.SELECT_WIDGET_TEACHER_SECTION_SELECTED,
        {section, isReload},
      ).then((persons) => {
        resolve(persons);
        status.setLoad();
      }).catch(() => {
        reject();
        status.setError();
      });
    }); 
  }

  loadComponent(sectionItem: WidgetTeacherSectionItem, componentName: string) {
    this.myComponent = null;
    this.$nextTick(()=> {
      this.myComponent = componentName;
      this.sectionItemSelected = sectionItem;
      this.currentHomework = sectionItem.response;
    });
  }

  saveComponent(params: any) {
    if(this.myComponent == 'ed-homework-grade'){
      this.savingGrade(params);
    }else if(this.myComponent == 'ed-homework-feedback'){
      this.savingFeedback(params);
    }
  }

  closeComponent() {
    this.myComponent = null;
  }

  clickShowFeedback(sectionItem: WidgetTeacherSectionItem) {
    this.loadComponent(sectionItem, 'ed-homework-feedback');
  }

  clickShowGrade(sectionItem: any) {
    this.sectionItemSelected = sectionItem;
    this.loadComponent(sectionItem, 'ed-homework-grade');
  }

  savingGrade(data: any) {
    this.sectionItemSelected.response.grade = data.grade;
    this.isSaving = true;
    this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.SET_TEACHER_HOMEWORK_GRADE, 
      { req: this.sectionItemSelected.response, student: this.sectionItemSelected.student }
    ).finally(() => {
      this.isSaving = false;
      this.myComponent = null;
    });
  }

  savingFeedback(data: any) {
    let params = this.getParamsBaseToFeedback(data);
    this.$EdModal.createModal(data.modal,  params);
  }

  formatFileFeedback(data: any) {
    return {
      homework: {
        id: this.currentHomework.id,
        name: data.name,
        description: data.description,
        type: data.type,
        classId: this.sectionSelected.classId
      },
      isResponse: false
    }
  }

  getParamsBaseToFeedback(data: any) {
    let params: any = {
      section : {
        name: this.$i18n.t(`common.${data.type}`),
        classId: this.sectionSelected.classId,
        type: data.code,
      },
      canSetHomework: false,
      titleModal : `${this.$i18n.t(`common.${data.type}`)} ${this.$i18n.t('common.feedback')}`,
      objId: this.sectionSelected.id,
      modalBusSaveEvent: HOMEWORKS_EVENTS.SEND_FEEDBACK_TO_STUDENT,
      formatData: this.formatFileFeedback,
      hasGradeField: true
    }
    if(data.code == SECTION_TYPES.LESSON_TEMP_FILE.code || data.code == SECTION_TYPES.LESSON_IMAGES.code) {
      let dropOptions: any = {
        url: HOMEWORKS_API.UPDATE_HOMEWORK.replace('{homeworkId}', this.currentHomework.id),
        autoProcessQueue: false,
        acceptedFiles: 'application/pdf,.epub,.docx,.doc,.xlsx,.xls,.pptx,.ppt',
        addRemoveLinks: false,
        maxFiles: 1,
        paramName: 'homeworkResource',
        parallelUploads: 1,
        createImageThumbnails: false,
        method: 'put'
      }
      if(data.code == SECTION_TYPES.LESSON_IMAGES.code) {
        dropOptions.createImageThumbnails = true;
        dropOptions.acceptedFiles= 'image/*';
      } else {
        dropOptions.maxFilesize = 200;
        dropOptions.timeout= 90000;
      }
      params.modalBusSaveEvent= `${HOMEWORKS_EVENTS.SEND_FEEDBACK_TO_STUDENT}_FILE_MANUALLY`
      params.dropOptions = dropOptions;
    }
    return params;
  }

  saveModal(data: any, params: any) {
    switch (params.section.type) {
      case SECTION_TYPES.LESSON_TEXT.code:
      case SECTION_TYPES.LESSON_EXTERNAL_LINK.code:
      case SECTION_TYPES.LESSON_VIDEO.code:
        if(params.section) {
          if(params.section.type !== null) data.type = params.section.type;
        }
        (this.$root.$children[0].$children[0].$refs.EdLoading as any).show();
        this.$store.dispatch(_HOMEWORKS_STORE.ACTIONS.SEND_FEEDBACK_TO_STUDENT, { 
          req: {
            id: this.currentHomework.id,
            classId: this.sectionSelected.classId,
            name: data.name,
            description: data.description,
            type: data.type,
            text: data.text
          },
          student: this.sectionItemSelected.student,
          file: null
        }).finally(() => {
          this.closeComponent();
          this.$EdModal.$emit(`${HOMEWORKS_EVENTS.SEND_FEEDBACK_TO_STUDENT}_CLOSE`);
          (this.$root.$children[0].$children[0].$refs.EdLoading as any).hide();
        });
      break;
    }
  }

  updateFeedback() {
    this.currentHomework.status = HOMEWORK_STATUS.GRADED;
    this.$store.commit(STORE.HOMEWORKS.MUTATIONS.UPDATE_RESPONSE_WIDGET_TEACHER_SECTION, { 
      student: this.sectionItemSelected.student, 
      response: this.currentHomework
    });
  }

  created() {
    this.$edEventBus.$on(HOMEWORKS_EVENTS.LOAD_SECTION_TEACHER_WIDGET, this.setSection);
    this.$edEventBus.$on(HOMEWORKS_EVENTS.SEND_FEEDBACK_TO_STUDENT, this.saveModal);
    this.$edEventBus.$on(`${HOMEWORKS_EVENTS.SEND_FEEDBACK_TO_STUDENT}_FILE_MANUALLY`, () => {
      this.updateFeedback();
      this.closeComponent();
      this.$EdModal.$emit(`${HOMEWORKS_EVENTS.SEND_FEEDBACK_TO_STUDENT}_FILE_MANUALLY_CLOSE`);
    });
    this.$edEventBus.$on(HOMEWORKS_EVENTS.RELOAD_SECTION_TEACHER_WIDGET, this.reloadSection);
  }

  mounted() {
    if(this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.sectionSelected) {
      this.personsStatus.setLoad();
      this.setSection({section: this.$store.state.HomeworksStore.teacherWidgetHomeworksSection.sectionSelected, isReload: false});
    }
  }

  beforeDestroy() {
    this.$edEventBus.$off(HOMEWORKS_EVENTS.LOAD_SECTION_TEACHER_WIDGET, this.setSection);
    this.$edEventBus.$off(HOMEWORKS_EVENTS.RELOAD_SECTION_TEACHER_WIDGET, this.reloadSection);
  }


}